function Collection(container) {
  var sectionId = container.getAttribute('data-section-id');
  var Carousel = document.getElementById('glider-carousel-' + sectionId);
  if (Carousel) {
    Sliders(container);
  }
}

sectionEvents.forEach(function(sectionEvent){
  let sectionContainer = sectionEvent.detail;
  let sectionType = sectionContainer.dataset.sectionType;  
  Collection(sectionContainer);
})

theme.Collection = (function() {
  function Collection(container) {
    var sectionId = container.getAttribute('data-section-id'),
        l = container.getAttribute('data-layout'),
        aB = document.getElementById('ajaxBusy'),
        cG = document.querySelector('#collection-grid');
    var listingRequestId = 0;
    var ajaxLoadPage = function (url, navigation = {}) {
      if (window.SecondgearUx && !window.SecondgearUx.isSameStoreUrl(url)) return;
      var requestId = ++listingRequestId;
      window.SecondgearUx?.beforeListingUpdate();
      aB.style.display = 'block';
      fetch(url)
      .then(response => {
        if (!response.ok) throw new Error('Listing response failed');
        return response.text();
      })
      .then(data => {
        if (requestId !== listingRequestId) return;
        var c = document.getElementById('collection-products'),
            f = document.getElementById('sorting');
        const htmlDocument = new DOMParser().parseFromString(data, 'text/html');
        var nC = htmlDocument.querySelector('#collection-products'),
            nF = htmlDocument.querySelector('#sorting');
        var m = container.querySelector('[data-secondgear-listing-state]'),
            nM = htmlDocument.querySelector('[data-secondgear-listing-state]');
        if (!c || !nC || !m || !nM) throw new Error('Listing markup missing');
        var collectionRoot = document.getElementById('collection');
        if (nF && !f && !collectionRoot) throw new Error('Listing controls position missing');
        // Replace optional controls as a unit, including zero-result transitions.
        if (f && nF) f.replaceWith(nF);
        else if (f) f.remove();
        else if (nF) collectionRoot.before(nF);
        c.replaceWith(nC);
        m.replaceWith(nM);
        Wrap();
        filters.action();
        if (l == 'form') {
          Order(container);
        } else {
          if (theme.settings.quickView) Quick();
          if (theme.settings.compare) CompareProducts();
        }
        PriceChange();
        Swatches(container);
        if (theme.settings.cart) Cart(container);
        if (navigation.history !== false && url !== window.location.href) {
          history.pushState({ page: url, secondgearListing: true }, '', url);
        }
        if (htmlDocument.title) document.title = htmlDocument.title;
        var canonical = document.querySelector('link[rel="canonical"]'),
            nextCanonical = htmlDocument.querySelector('link[rel="canonical"]');
        if (canonical && nextCanonical?.getAttribute('href')) canonical.setAttribute('href', nextCanonical.getAttribute('href'));
        document.dispatchEvent(new CustomEvent('secondgear:listing-updated'));
        var s = cG.getBoundingClientRect().top + window.pageYOffset;
        window.setTimeout(function() {
          if (requestId !== listingRequestId) return;
          if (!window.SecondgearUx?.filterIsOpen() && !navigation.preserveScroll) {
            window.scrollTo({top:s - document.selectors.sht, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
          }
        }, 0);
        aB.style.display = 'none';
      }).catch(function () {
        if (requestId !== listingRequestId) return;
        aB.style.display = 'none';
        // Normal GET restores matching URL/document, including failed popstate.
        window.location.assign(url);
      });
    };
    var filters = {
      action:function (e) {
        var pA = container.querySelectorAll('.paginateBy'),
            sB = container.querySelector('select.sortBy');
        pA.forEach(function(p) {
          p.onclick = function(ev){ 
            var u = new URL(window.location),
                params = u.searchParams;
            u.search = params.toString();
            var url = u.toString(),
                pag = this.textContent;
            aB.style.display = 'block';
            fetch(theme.routes_cart_url + '.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({attributes: {'pagination': pag }})
            }).then(function () {
              ajaxLoadPage(url);
            });
          }
        });        
        var fA = container.querySelectorAll('.advanced-filter a');
        fA.forEach(function(f) {
          f.onclick = function(ev){   
            ev.preventDefault();
            var url = f.getAttribute('href');
            ajaxLoadPage(url);
          }
          f.onmouseenter = function(){
            f.classList.add('hover');
          };
          f.onmouseleave = function(){
            f.classList.remove('hover');
          };
        });      
        var dS = container.querySelectorAll('.dropdown select');
        dS.forEach(function(d) {
          d.onchange = function(){
            if (d.value) {
              location.href = d.value;
            }
            else {
              location.href = theme.routes_all_products_collection_url;
            }
          };
        });        
        if (sB) {
          sB.onchange = function(s){
            var u = new URL(window.location),
                params = u.searchParams;
            params.delete('page');
            params.set('sort_by', this.value);
            u.search = params.toString();
            var url = u.toString();
            ajaxLoadPage(url);
          };
        };
        var iW = theme.width,
            sD = document.querySelector('#sorting details'),
            dO = document.querySelectorAll('.open-container-filter.desktop > details');
        if (iW <= theme.breakpoint_margin) {
          if (sD) {
            sD.open = Boolean(window.SecondgearUx?.filterIsOpen());
          }
          dO.forEach(function(d) {
            d.open = false;
          });
        }            
      }
    };
    function PriceChange() {
      var mnV = document.getElementById('price-min'),
          mxV = document.getElementById('price-max'),
          pIN = container.querySelectorAll('.price-input[type="number"]'),
          pIR = container.querySelectorAll('.price-input[type="range"]');
      function PriceChangeType() {
        var u = new URL(window.location),
            paramsN = u.searchParams,
            paramsX = u.searchParams;
        paramsN.delete('page');
        paramsN.set(mnV.getAttribute('data-url'), mnV.value);
        paramsX.set(mxV.getAttribute('data-url'), mxV.value);
        u.search = paramsN.toString();
        u.search = paramsX.toString();
        var url = u.toString();
        ajaxLoadPage(url);
      }
      pIN.forEach(function(p) {        
        let timeout;
        p.addEventListener('keyup', function (e) {
          if (e.keyCode != 9) {          
            clearTimeout(timeout);
            timeout = setTimeout(function () {
              PriceChangeType();
            }, 750);
          }
        });
      });      
      pIR.forEach(function(p) {
        p.addEventListener('change', PriceChangeType);
      });
    };
    PriceChange();
    filters.action();
    Swatches(container);
    if (theme.settings.cart) {
      Cart(container);
    }
    var popped = ('state' in window.history && window.history.state !== null);
    var initialURL = location.href;
    window.onpopstate = function () {
      ajaxLoadPage(window.location.href, { history: false, preserveScroll: true });
    };
    Shopify.queryParams = {};
    if (location.search.length) {
      for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
        aKeyValue = aCouples[i].split('=');
        if (aKeyValue.length > 1) {
          Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
        }
      }
    }
    Collection.prototype.onSelect = function(ev) {
      var Carousel = document.getElementById('glider-carousel-' + sectionId);
      if (Carousel) {
        Sliders(container);
      }
      if (theme.settings.quickView) {
        Quick();
      };
      if (theme.settings.compare) {
        CompareProducts();
      };
      Wrap();
    }
  }
  return Collection;
})();